import type { ComputedRef } from 'vue';
import { createContext } from 'reka-ui';

interface AuthProviderFormContext {
	state: Record<string, unknown>;
	previewProviderName: ComputedRef<string>;
}

export const [injectAuthProviderFormContext, provideAuthProviderFormContext] =
	createContext<AuthProviderFormContext>('AuthProviderForm');
